import {
  BANK_STATE, DOOR_LOCK_STATE, DOOR_STATE,
  PARKING_METER_STATUS,
  PARKING_SERVER_STATE,
  PAYMENT_CONTROLLER_STATE, POWER_STATE, POWER_SUPPLY,
  PRINTER_STATE,
} from './constants';

export const getMetricValue = metrics => function (name, defValue = null) {
  return metrics && typeof metrics[name] ? metrics[name] : defValue;
};
export const getPrinterStatus = metrics => {
  const printerState = Number(getMetricValue(metrics)('PRINTER_STATE'));
  let data = { status: PARKING_METER_STATUS.WARNING, statusText: 'Нет данных' };
  if (printerState === PRINTER_STATE.OK) {
    data = { status: 0, statusText: 'В работе' };
  }
  if (printerState === PRINTER_STATE.PAPER_LOW) {
    data = { status: PARKING_METER_STATUS.WARNING, statusText: 'Мало бумаги' };
  }
  if (printerState === PRINTER_STATE.PAPER_EMPTY) {
    data = { status: PARKING_METER_STATUS.ERROR, statusText: 'Бумага закончилась' };
  }
  if (printerState === PRINTER_STATE.ERROR) {
    data = { status: PARKING_METER_STATUS.ERROR, statusText: 'Ошибка' };
  }
  return data;
};

export const getParkingServerStatus = metrics => {
  const state = Number(getMetricValue(metrics)('PARKING_SERVER_STATE'));
  if (state === PARKING_SERVER_STATE.OK) {
    return { status: 0, statusText: 'На связи' };
  }
  if (state === PARKING_SERVER_STATE.ERROR) {
    return { status: -99, statusText: 'Ошибка' };
  }
  if (state === PARKING_SERVER_STATE.UNREGISTERED) {
    return { status: -99, statusText: 'Не зарегистрирован' };
  }
  return { status: PARKING_METER_STATUS.WARNING, statusText: 'Нет данных' };
};

export const getBankStatus = metrics => {
  const bankState = Number(getMetricValue(metrics)('BANK_STATE'));
  if (bankState === BANK_STATE.OK) {
    return { status: 0, statusText: 'На связи' };
  }
  if (bankState === BANK_STATE.ERROR) {
    return { status: -99, statusText: 'Нет связи' };
  }
  return { status: PARKING_METER_STATUS.WARNING, statusText: 'Нет данных' };
};

export const getPowerStatus = metrics => {
  const state = Number(getMetricValue(metrics)('POWER_STATE'));
  if (state === POWER_STATE.OK) {
    return { status: 0, statusText: 'В работе' };
  }
  if (state === POWER_STATE.ERROR) {
    return { status: PARKING_METER_STATUS.ERROR, statusText: 'Ошибка' };
  }
  if (state === POWER_STATE.LOW_POWER) {
    return { status: PARKING_METER_STATUS.WARNING, statusText: 'Требуется замена' };
  }
  return { status: PARKING_METER_STATUS.WARNING, statusText: 'Нет данных' };
};

export const getPaymentBlockStatus = metrics => {
  const paymentState = Number(getMetricValue(metrics)('PAYMENT_CONTROLLER_STATE')) || 0;
  if (paymentState === PAYMENT_CONTROLLER_STATE.ERROR) {
    return { status: PARKING_METER_STATUS.ERROR, statusText: 'Ошибка' };
  }
  if (paymentState === PAYMENT_CONTROLLER_STATE.UNKNOWN) {
    return { status: PARKING_METER_STATUS.WARNING, statusText: 'Нет данных' };
  }
  if (paymentState === PAYMENT_CONTROLLER_STATE.IDLE) {
    return { status: 0, statusText: 'Ожидает' };
  }
  if (paymentState === PAYMENT_CONTROLLER_STATE.WAIT_CARD) {
    return { status: 0, statusText: 'Ожидается карта' };
  }
  if (paymentState === PAYMENT_CONTROLLER_STATE.WAIT_BANK) {
    return { status: 0, statusText: 'Соединение с банком' };
  }
  if (paymentState === PAYMENT_CONTROLLER_STATE.COMPLETE) {
    return { status: 0, statusText: 'На связи' };
  }
  return { status: PARKING_METER_STATUS.WARNING, statusText: 'Нет данных' };
};

export const sortByStatus = (a, b) => {
  if (a.status < b.status) {
    return -1;
  }
  if (a.status > b.status) {
    return 1;
  }
  return 0;
};

export const convertMetricFilters = filterData => {
  const filterConfig = {
    DOOR_UPPER_STATE: {
      DOOR_UPPER_UNKNOWN: DOOR_STATE.UNKNOWN,
      DOOR_UPPER_OPENED: DOOR_STATE.OPENED,
      DOOR_UPPER_CLOSED: DOOR_STATE.CLOSED,
    },
    DOOR_LOWER_STATE: {
      DOOR_LOWER_UNKNOWN: DOOR_STATE.UNKNOWN,
      DOOR_LOWER_OPENED: DOOR_STATE.OPENED,
      DOOR_LOWER_CLOSED: DOOR_STATE.CLOSED,
    },
    DOOR_UPPER_LOCK_STATE: {
      DOOR_LOCK_UPPER_ERROR: DOOR_LOCK_STATE.ERROR,
      DOOR_LOCK_UPPER_UNKNOWN: DOOR_LOCK_STATE.UNKNOWN,
      DOOR_LOCK_UPPER_LOCKED: DOOR_LOCK_STATE.LOCKED,
      DOOR_LOCK_UPPER_UNLOCKED_CLOSED: DOOR_LOCK_STATE.UNLOCKED_CLOSED,
      DOOR_LOCK_UPPER_UNLOCKED_OPENED: DOOR_LOCK_STATE.UNLOCKED_OPENED,
    },
    DOOR_LOWER_LOCK_STATE: {
      DOOR_LOCK_LOWER_ERROR: DOOR_LOCK_STATE.ERROR,
      DOOR_LOCK_LOWER_UNKNOWN: DOOR_LOCK_STATE.UNKNOWN,
      DOOR_LOCK_LOWER_LOCKED: DOOR_LOCK_STATE.LOCKED,
      DOOR_LOCK_LOWER_UNLOCKED_CLOSED: DOOR_LOCK_STATE.UNLOCKED_CLOSED,
      DOOR_LOCK_LOWER_UNLOCKED_OPENED: DOOR_LOCK_STATE.UNLOCKED_OPENED,
    },
    PARKING_SERVER_STATE: {
      PSS_UNKNOWN: PARKING_SERVER_STATE.UNKNOWN,
      PSS_ERROR: PARKING_SERVER_STATE.ERROR,
      PSS_UNREGISTERED: PARKING_SERVER_STATE.UNREGISTERED,
      PSS_OK: PARKING_SERVER_STATE.OK,
    },
    PRINTER_STATE: {
      PS_ERROR: PRINTER_STATE.ERROR,
      PS_PAPER_EMPTY: PRINTER_STATE.PAPER_EMPTY,
      PS_PAPER_LOW: PRINTER_STATE.PAPER_LOW,
      PS_UNKNOWN: PRINTER_STATE.UNKNOWN,
      PS_OK: PRINTER_STATE.OK,
    },
    POWER_STATE: {
      POWER_ERROR: POWER_STATE.ERROR,
      POWER_LOW_POWER: POWER_STATE.LOW_POWER,
      POWER_UNKNOWN: POWER_STATE.UNKNOWN,
      POWER_OK: POWER_STATE.OK,
    },
    PAYMENT_CONTROLLER_STATE: {
      PAYMENT_ERROR: PAYMENT_CONTROLLER_STATE.ERROR,
      PAYMENT_UNKNOWN: PAYMENT_CONTROLLER_STATE.UNKNOWN,
      PAYMENT_IDLE: PAYMENT_CONTROLLER_STATE.IDLE,
      PAYMENT_WAIT_CARD: PAYMENT_CONTROLLER_STATE.WAIT_CARD,
      PAYMENT_WAIT_BANK: PAYMENT_CONTROLLER_STATE.WAIT_BANK,
      PAYMENT_COMPLETE: PAYMENT_CONTROLLER_STATE.COMPLETE,
    },
  };
  const metrics = {};
  const keys = Object.keys(filterConfig);
  for (let i = 0, len = keys.length; i < len; i++) {
    const key = keys[i];
    const options = filterConfig[key];
    const optionsKeys = Object.keys(options);
    const values = [];
    for (let j = 0, len2 = optionsKeys.length; j < len2; j++) {
      const optionName = optionsKeys[j];
      if (filterData && filterData[optionName]) {
        values.push(options[optionName]);
      }
      delete filterData[optionName];
    }
    if (values && values.length) {
      metrics[key] = values;
    }
  }
  if (Object.keys(metrics).length) {
    filterData.metrics = metrics;
  }
  return filterData;
};

export function getCheckClassByName(name) {
  const errorKeys = [
    'DOOR_LOCK_LOWER_ERROR',
    'DOOR_LOCK_UPPER_ERROR',
    'PSS_ERROR',
    'PS_ERROR',
    'PS_PAPER_EMPTY',
    'POWER_ERROR',
    'PAYMENT_ERROR',
    'PSS_UNREGISTERED',
  ];
  const warningKeys = [
    'DOOR_LOWER_UNKNOWN',
    'DOOR_UPPER_UNKNOWN',
    'DOOR_LOCK_LOWER_UNKNOWN',
    'DOOR_LOCK_UPPER_UNKNOWN',
    'PSS_UNKNOWN',
    'PS_PAPER_LOW',
    'PS_UNKNOWN',
    'POWER_LOW_POWER',
    'POWER_UNKNOWN',
    'PAYMENT_UNKNOWN',
  ];
  if (errorKeys.includes(name)) {
    return 'error-checkbox';
  }
  if (warningKeys.includes(name)) {
    return 'warning-checkbox';
  }
  return 'ok-checkbox';
}
